import { render, staticRenderFns } from "./CreateManualInvoicePage.vue?vue&type=template&id=28e48bc2&scoped=true"
import script from "./CreateManualInvoicePage.vue?vue&type=script&lang=js"
export * from "./CreateManualInvoicePage.vue?vue&type=script&lang=js"
import style0 from "./CreateManualInvoicePage.vue?vue&type=style&index=0&id=28e48bc2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28e48bc2",
  null
  
)

export default component.exports